// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2ZsWz","label":"Section_label__1Jkgv","contentWrap":"Section_contentWrap__3nCXI","footer":"Section_footer__1j9kW","footerInner":"Section_footerInner__ZQ3J_"};